import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import { Button } from '@mui/material'
import { Link } from 'react-router-dom'
import * as css from './styles'
import { t } from '@lingui/core/macro'

export enum VariantTypes {
  INFO = 'info',
  WARNING = 'warning',
}

const VARIANT_OPTIONS = {
  info: {
    message: {
      text: 'The data in this submission can now be found on the dataset. Navigate to the dataset for an aggregate view of submission data for this template.',
      color: '#0D3C61',
    },
    color: '#2196F3',
    background: '#E9F5FE',
    icon: <InfoOutlinedIcon style={{ color: '#2196F3', width: 20, height: 20 }} />,
  },
  warning: {
    message: {
      text: 'We’ve detected changes to the data found on this submission. To ensure you’re viewing the most recent updates, view and edit rows directly from the dataset.',
      color: '#663D00',
    },
    color: '#FF9800',
    background: 'rgba(255, 152, 0, 0.1)',
    icon: <WarningAmberOutlinedIcon style={{ color: '#FF9800', width: 20, height: 20 }} />,
  },
}

interface DatasetBannerProps {
  datasetId: number
  variant?: VariantTypes
}

export function DatasetBanner({ datasetId, variant = VariantTypes.INFO }: DatasetBannerProps) {
  return (
    <css.Container style={{ background: VARIANT_OPTIONS[variant].background }}>
      <css.FlexBox>
        {VARIANT_OPTIONS[variant].icon}
        <css.Message style={{ color: VARIANT_OPTIONS[variant].message.color }}>
          {VARIANT_OPTIONS[variant].message.text}
        </css.Message>
      </css.FlexBox>
      <Link to={`/template/${datasetId}/data`}>
        <Button
          color="primary"
          variant="contained"
          size="small"
          style={{ boxShadow: 'none', fontSize: 14, padding: '2px 10px' }}
        >
          {t`View dataset`}
        </Button>
      </Link>
    </css.Container>
  )
}
